import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-581c0dbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown use-contacts" }
const _hoisted_2 = {
  type: "button",
  class: "btn btn-inline btn-link dropdown-toggle",
  "data-bs-toggle": "dropdown"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "dropdown-menu dropdown-menu-sm-end" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_7 = { key: "none" }
const _hoisted_8 = ["disabled"]

import { computed, nextTick } from "vue"
import { ContactProvider, contactProviders } from "@/manage/contacts/ContactProviders"
import { useContactStore } from "./ContactStore"


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactProviderSelector',
  setup(__props) {

const contactStore = useContactStore()

const selectedContactProviderRef = computed(() => contactProviders.find(cp => cp.id == contactStore.contactProviderId))

async function useContacts(cp: ContactProvider | undefined) {
  contactStore.contactProviderId = cp?.id ?? ''
  await nextTick()
  if (cp) {
    try {
      const authorized = await cp.signIn()

      if (authorized) {
        await contactStore.ensureContactsLoadedAsync()
      } else {
        // TODO: Handle the case where signIn returned false
        // change display selection?
      }
    } catch (error) {
      // is this possible?
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      (selectedContactProviderRef.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["contact-provider-icon", { [selectedContactProviderRef.value.id]: true }])
          }, null, 2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "Use contacts"))
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactProviders), (cp) => {
        return (_openBlock(), _createElementBlock("li", {
          key: cp.id
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["dropdown-item", { [cp.id]: true, active: cp.id == selectedContactProviderRef.value?.id }]),
            onClick: ($event: any) => (useContacts(cp))
          }, " Use " + _toDisplayString(cp.name), 11, _hoisted_5)
        ]))
      }), 128)),
      _hoisted_6,
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "dropdown-item",
          disabled: !selectedContactProviderRef.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (useContacts(undefined)))
        }, " Don't use my contacts ", 8, _hoisted_8)
      ])
    ])
  ]))
}
}

})